function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2004 102.164C55.7625 100.602 55.7625 98.069 54.2004 96.5069L51.1108 93.4173C49.5487 91.8552 47.016 91.8552 45.4539 93.4173L27.7534 111.118C25.3382 113.533 25.3382 117.449 27.7534 119.864C30.1687 122.279 34.0846 122.279 36.4999 119.864L54.2004 102.164Z",
  fill: "#EDEDED"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  width: 11.9983,
  height: 11.2054,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 56.8975 99.2041)",
  fill: "#DEDEDE"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  r: 37.6181,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 75.9997 71.9399)",
  fill: "#EDEDED"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  r: 32.0154,
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 75.9993 71.9399)",
  fill: "#F4F4F4"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  r: 27.2131,
  transform: "matrix(0.707107 0.707107 0.707107 -0.707107 75.9998 71.9399)",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M91.0921 88.3457C82.0276 97.4103 67.3311 97.4103 58.2666 88.3458L91.0921 55.5202C100.157 64.5847 100.157 79.2812 91.0921 88.3457Z",
  fill: "#FBFBFB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.4 84.1C93.7917 84.1 83.6001 94.2916 83.6001 106.9C83.6001 119.508 93.7917 129.7 106.4 129.7C119.008 129.7 129.2 119.508 129.2 106.9C129.2 94.2916 119.008 84.1 106.4 84.1Z",
  fill: "#DEDEDE"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 116.227,
  y: 113.042,
  width: 5.21143,
  height: 22.5828,
  rx: 2,
  transform: "rotate(135 116.227 113.042)",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 100.258,
  y: 116.727,
  width: 5.21143,
  height: 22.5829,
  rx: 2,
  transform: "rotate(-135 100.258 116.727)",
  fill: "white"
});

var SvgSearchError = function SvgSearchError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 153,
    viewBox: "0 0 152 153",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-error.7d18b1dd.svg";
export { ForwardRef as ReactComponent };